import EditTermContainer from "./EditPaymentTermContainer";
export default EditTermContainer;
